import React from "react";
import {Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {orangeBackgroundColor} from "../../../constants";
import {FloorPlan} from "../../Plan/Configuration/Floor/FloorPlan";
import {useForwardPlanStepKeyboardShortcuts} from "../forwardPlanStepKeyboardShortcuts";
import DisabledOverlay from "../DisabledOverlay";
import {useSelector} from "react-redux";

const TextGridItem = () => {
  return (
    <Grid size={12} key={'upper_text'}>
      <Typography component="p" variant="body2" align={'center'} style={{fontSize: 0.92 + 'rem'}}>
        Positionieren Sie die Abflüsse per Drag & Drop auf dem Boden. Mit einem Doppelklick entfernen Sie das Element.
      </Typography>
    </Grid>
  )
}

export const FloorStep = () => {
  const {childRef} = useForwardPlanStepKeyboardShortcuts();
  const plan = useSelector(state => state.plan);
  const readOnly = !plan.floor || plan.floor.isStockFloor;

  return (
    <Paper square={true} sx={{
      position: 'relative',
      background: orangeBackgroundColor,
      padding: '1em 2em 2em 2em',
      overflow: 'hidden' // prevents overlay from exceeding the paper

    }} elevation={10}>
      <Grid container spacing={1}>
        <TextGridItem/>
        <Grid size={12}>
          <FloorPlan
            childRef={childRef}
            isToolbarVisible={true}
          />
        </Grid>
      </Grid>
      {readOnly && <DisabledOverlay message={"Standard Böden können nicht konfiguriert werden!"} /> }
    </Paper>
  )
};
